import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const bookmarksApi = createApi({
  reducerPath: 'bookmarksApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Bookmarks'],
  endpoints: (builder) => ({
    getLists: builder.query({
      query: () => '/bookmarks',
      providesTags: ['Bookmarks'],
    }),
    addItem: builder.mutation({
      query: ({ listId, materialId }) => ({
        url: `/bookmarks/${listId}/items`,
        method: 'POST',
        body: { material_id: materialId },
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    removeItem: builder.mutation({
      query: ({ listId, materialId }) => ({
        url: `/bookmarks/${listId}/items/${materialId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    createList: builder.mutation({
      query: ({ name, colorId }) => ({
        url: '/bookmarks',
        method: 'POST',
        body: { name, color_id: colorId },
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    getColors: builder.query({
      query: () => '/bookmarks/colors',
    }),
  }),
});

export const {
  useGetListsQuery,
  useAddItemMutation,
  useRemoveItemMutation,
  useCreateListMutation,
  useGetColorsQuery,
} = bookmarksApi;
